import React, { Component } from 'react';
// import ReactDataGrid from 'react-data-grid';
import { connect } from 'react-redux';
import * as IntroductionList from './Saga/IntroductionList';
import RoomDocComponent from '../Rooms/RoomDocComponent';
// import * as Responses from '../../Store/Responses';
import '../../Css/GridRooms.css';
import LoadingComponent from '../Layout/LoadingComponent';
import moment from 'moment';
import { Modal, Row, Col, ModalHeader, ModalFooter, Button, ModalBody } from 'reactstrap';
import IntroductionsGridComponent from './IntroductionsGridComponent';
import EstimateComponent from '../Estimates/Index';
import YoyakuBuildingComponent from '../YoyakuBuilding/Index';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import MuiButton from '@mui/material/Button';
// import RoomListSearch from './RoomListSearch';

// import * as ReactDataGrid from "react-data-grid";
// import { Toolbar, Data } from "react-data-grid-addons";
interface Props {

    rent_response_id: number,

    insert_introductions: any,
    get_introductions: any,

    delete_introduction: any,
    update_open_introductions: any,
    togglefileup: any,
    room_details: any,
    update_introduction_list_toiawase: any,
    responsedetail: any,
    user_details: any,
    users: any,
    customer_details: any,
}


interface State {

    modalsheet: boolean,
    modalestimates: boolean,
    tatemono_id: number,
    room_id: number,
    // state types

    modalYoyaku: boolean,
}







class App extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {

            modalsheet: false,
            tatemono_id: 0,
            room_id: 0,
            modalestimates: false,
            modalYoyaku:false,


        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.selectTatemono = this.selectTatemono.bind(this);
        this.onMypage = this.onMypage.bind(this);

        this.toiawase = this.toiawase.bind(this);

        this.selectsheet = this.selectsheet.bind(this);

        this.togglesheet = this.togglesheet.bind(this);
        this.estimate = this.estimate.bind(this);
        this.yoyaku = this.yoyaku.bind(this);
        this.props.get_introductions({ rent_response_id: props.rent_response_id });
    }


    //     submit(state:any){
    //         console.log(state)
    // this.props.get_response_rooms(state)
    //     }
    handleSubmit(state: any) {
        console.log(state)


        state.rentResponseId = this.props.rent_response_id;


        // this.props.actions.get_response_rooms(state);

    }

    selectTatemono(tatemonoId: string, roomId: string) {
        // let  data={rentResponseId:this.props.responseid,tatemonoId:tatemonoId,roomId:roomId}

        let insertdata = {
            rentResponseId: this.props.rent_response_id,
            tatemono_id: tatemonoId,
            status: 2,

            room_id: roomId,

        };


        this.props.insert_introductions(insertdata)
    }

    selectsheet(row: any) {
        console.log(row)
        if (row)
            this.setState(prevState => ({
                modalsheet: !prevState.modalsheet,
                tatemono_id: row.tatemono_id,
                room_id: row.room_id
            }));
    }
    onMypage(value: any) {
        // let  data={rentResponseId:this.props.responseid,tatemonoId:tatemonoId,roomId:roomId}

        let updatedata = {
            id: value.id,
            rent_response_id: this.props.rent_response_id,
            tatemono_id: value.tatemono_id,
            room_id: value.room_id,
            section_id: value.section_id,

            status: value.status,
            on_mypage: value.on_mypage === 1 ? 0 : 1,
            intro_flag: value.intro_flag,
            numbering: value.numbering,
            created_at: value.created_at,
            created_user: value.created_user,
            send_flag: value.send_flag,
            remarks: value.remarks,
        };



        this.props.update_open_introductions(updatedata)
    }


    toiawase(value: any) {
        // let  data={rentResponseId:this.props.responseid,tatemonoId:tatemonoId,roomId:roomId}

        let updatedata = {
            id: value.id,
            rent_response_id: this.props.rent_response_id,
            tatemono_id: value.tatemono_id,
            room_id: value.room_id,
            section_id: value.section_id,

            status: value.status === 1 ? 0 : 1,
            on_mypage: value.on_mypage,
            intro_flag: value.intro_flag,
            numbering: value.numbering,
            created_at: value.created_at,
            created_user: value.created_user,
            send_flag: value.send_flag,
            remarks: value.remarks,
        };



        this.props.update_introduction_list_toiawase(updatedata)
    }

    togglesheet = () => {

        this.setState(prevState => ({
            modalsheet: !prevState.modalsheet,

        }));
    }


    estimate(tatemonoId: any, roomId: any) {
        this.setState({ tatemono_id: tatemonoId, room_id: roomId })


        this.toggleestimates()
    }


    toggleestimates = () => {

        this.setState(prevState => ({
            modalestimates: !prevState.modalestimates,

        }));

    }

    yoyaku(tatemonoId: any, roomId: any) {
        this.setState({ tatemono_id: tatemonoId, room_id: roomId })


        this.toggleYoyaku()
    }

    toggleYoyaku = () => {

        this.setState(prevState => ({
            modalYoyaku: !prevState.modalYoyaku,

        }));

    }
    render() {
        // console.log(this.props.customerlists)
        // alert(this.props.customerlists+"sss")
        // const ss:any=[];
        return (

            <div >


                <IntroductionsGridComponent
                    rent_response_id={this.props.rent_response_id}
                    onMypage={this.onMypage}
                    selectsheet={this.selectsheet}
                    delete_introduction={this.props.delete_introduction}
                    togglefileup={this.props.togglefileup}
                    estimate={this.estimate}
                    add_mail_room={null}
                    togglesearch={null}
                    toiawase={this.toiawase}

                    yoyaku={this.yoyaku}
                />


                <Modal isOpen={this.state.modalsheet} toggle={this.togglesheet} size="xxl" fade={false}>
                    <ModalHeader toggle={this.togglesheet}><b style={{ fontSize: "20px" }}>{this.props.room_details.tatemono_name} {this.props.room_details.room_name}</b></ModalHeader>

                    < RoomDocComponent tatemonoId={this.state.tatemono_id} roomId={this.state.room_id} />

                </Modal>



                <Modal isOpen={this.state.modalestimates} zIndex={3000} size="xxl" fade={false}>

                    <ModalHeader toggle={this.toggleestimates}>見積作成</ModalHeader>
                    <ModalBody style={{ background: "#9fb6cc" }}>
                        <EstimateComponent rentEstimateId={0}
                            tatemonoId={this.state.tatemono_id.toString()}
                            roomId={this.state.room_id.toString()} />
                    </ModalBody>
                    <ModalFooter>
                        {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_auto_send}>除外する</button> */}
                        <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={this.toggleestimates}>閉じる</button>
                    </ModalFooter>
                </Modal>

                <Dialog open={this.state.modalYoyaku} maxWidth={"lg"} fullWidth onClose={(e) => { this.setState({ "modalYoyaku": false });}}>

                    <DialogTitle>空き待ち予約</DialogTitle>
                    <YoyakuBuildingComponent 
                        detail={
                            {
                                tatemono_id: this.state.tatemono_id.toString(),
                                // room_id: this.state.room_id.toString(),
                                room_id: "",
                                no: "",
                                is_park: 0,
                                park_bikou: '',
                                reg_date: moment().format("YYYY-MM-DD"),
                                is_renraku_zumi: 0,
                                kokyaku_name: this.props.customer_details.name1,
                                tel: this.props.customer_details.tel1,
                                mail: this.props.customer_details.mail1,
                                renraku_bikou: '',
                                gyousha_name: '',
                                gyousha_tel: '',
                                gyousha_tantou: '',
                                gyousha_bikou: '',
                                bikou: '',
                                user_id: this.props.user_details.id,

                                rent_response_id: this.props.responsedetail.id


                            }
                        }
                        responsedetail={this.props.responsedetail}
                        user_details={this.props.user_details}
                        users={this.props.users}
                        onClose={this.toggleYoyaku}
                    />
                </Dialog>
            </div>


        );
    }


}



const mapStateToProps = (state: any) => {
    return {

        room_details: state.roomsReducer.room_details,
        responsedetail: state.responsesReducer.responsedetail,
        customer_details: state.customersReducer.customer_details,
        user_details: state.masterReducer.user_details,
        users: state.masterReducer.users,


    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        get_introductions(state: any) {
            dispatch(IntroductionList.get_introductions(state))
        },
        insert_introductions(state: any) {
            dispatch(IntroductionList.insert_introductions(state))
        },
        delete_introduction(state: any) {
            dispatch(IntroductionList.delete_introduction(state))
        },
        update_open_introductions(state: any) {
            dispatch(IntroductionList.update_open_introductions(state))
        },
        update_introduction_list_toiawase(state: any) {
            dispatch(IntroductionList.update_introduction_list_toiawase(state))
        },

    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);